import { render, staticRenderFns } from "./newTrainingCenter.vue?vue&type=template&id=6d24fe2e&scoped=true&"
import script from "./newTrainingCenter.vue?vue&type=script&lang=js&"
export * from "./newTrainingCenter.vue?vue&type=script&lang=js&"
import style0 from "./newTrainingCenter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./newTrainingCenter.vue?vue&type=style&index=1&id=6d24fe2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d24fe2e",
  null
  
)

export default component.exports